export const title = "Welcome to Imagica";
export const guideCotSubTitle = `Here's a quick video on how to create your AI app.\nAfterwards, you can start your first project.`;
export const guideManualSubTitle = `Here's a quick video on how to use nodes and \nedges to create your Al app\nAfterwards, you can start your first project.`;

export const endTitle = `That's It!`;
export const guideManualEndSubtitle = `Now you're ready to try out Imagica!`;
export const guideCotEndSubtitle = `You're now ready to try out Imagica.`;

export const manualVideo =
  "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/AskImagica_SearchEngine_RE2_ExportV1.webm";
export const cotVideo =
  "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/AutoImagica_Quick+Start_RE3_ExportV1.webm";
